import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Injectable()
export class ClipboardService {
  private dom: Document;

  constructor(@Inject(DOCUMENT) dom: Document) {
    this.dom = dom;
  }

  public copyToClipboard(searchterm: string) {
    if (searchterm) {
      const textArea = this.createTextArea();
      try {
        textArea.value = this.removeSpaces(searchterm);
        textArea.select();
        this.dom.execCommand('copy');
      }
      finally {
        if (textArea && textArea.parentNode) {
          textArea.parentNode.removeChild(textArea);
        }
      }
    }
  }

  private createTextArea(): any {
    let textarea;
    textarea = this.dom.createElement('textarea');
    textarea.style.height = '0px';
    textarea.style.left = '-100px';
    textarea.style.opacity = '0';
    textarea.style.position = 'fixed';
    textarea.style.top = '-100px';
    textarea.style.width = '0px';
    this.dom.body.appendChild(textarea);
    return textarea;
  }

  public removeSpaces(stringToFormat: string): string {
    return stringToFormat.replace(/[\s]/g, '');
  }

}
